import HiddenCardsDivider from './HiddenCardsDivider';

export default HiddenCardsDivider;
